export default "__VITE_ASSET__BxHkgSyx__"